module.exports = __webpack_public_path__ + "img/ic-calendar.a4671c27.svg";